// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"531":"e71cb0de","614":"baff155e","685":"8cfbbe46"}[chunkId] + ".chunk.js";
};